import { NetworkStatus } from '@apollo/client';

/**
 * Blocks loading state changes while the query is refetching (e.g. via a mutation's
 * refetchQueries, or a subscription-triggered refetch). This is necessary to prevent
 * loading: true flicker when using cache-and-network fetch policy.
 * See video with background: https://github.com/capital-markets-gateway/js/pull/9517/files#r1430320453
 */
export const suppressLoadingOnRefetch = (loading: boolean, networkStatus: NetworkStatus) =>
  loading && networkStatus !== NetworkStatus.refetch;
